import { loggerService } from 'js/services/logger.service';
import { type AnyAction, type MiddlewareAPI, type Dispatch } from 'redux';

export const publicAPI = (api: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
    if (action.type && loggerService.isEnabled()) {
        const reduxAPI = window.Playtech?.API?.redux || {};

        reduxAPI.prevState = api.getState();

        const result = next(action);

        reduxAPI.currentState = api.getState();

        if (window.Playtech?.API) {
            window.Playtech.API.redux = {
                ...window.Playtech.API.redux,
                ...reduxAPI,
                dispatch: api.dispatch
            };
        }

        return result;
    }

    return next(action);
};
